<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button
          type="success"
          size="mini"
          
          @click="getList"
          >刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px"
          @click="select()"
          >筛选</el-button
        >
          <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;background:#06CC00;border:1px solid #06CC00;margin-bottom: 5px;"
        @click="checkSuccessList(2)"
        >批量通过</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;background:#FF0000;border:1px solid #FF0000;margin-bottom: 5px;"
        @click="checkRejectList(2)"
        >批量拒绝</el-button
      >
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="margin: 0 10px;">用户</label>
          <el-input
            v-model="uid"
            placeholder="请输入用户"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px;">状态</label>
          <el-select v-model="status" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label="审核中" :value="0"></el-option>
          <el-option label="审核成功" :value="1"></el-option>
          <el-option label="审核拒绝" :value="2"></el-option>
        </el-select>
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px;">重复数 > </label>
          <el-input
            v-model="ipCount"
            placeholder="请输入重复数"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px;">ip</label>
          <el-input
            v-model="ip"
            placeholder="请输入ip"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 1161px"
        size="mini"
        @selection-change="handleSelectionChange"
      >
       <el-table-column type="selection" width="50" />
       <el-table-column prop="address" label="操作" width="130">
          <template slot-scope="scoped">
            <div style="display: flex;align-items: center;justify-content: center;" v-if="scoped.row.status == 0">
                <el-button type="success" size="mini" @click="checkSuccessList(1,scoped.row)">通过</el-button>
                <el-button type="danger" size="mini" @click="checkRejectList(1,scoped.row)">拒绝</el-button>
            </div>
            <div style="display: flex;align-items: center;justify-content: center;color:#06CC00" v-if="scoped.row.status == 1">
                已通过
            </div> 
            <div style="display: flex;align-items: center;justify-content: center;color: red;" v-if="scoped.row.status == 2">
                已拒绝
            </div>
          </template>
        </el-table-column> 
        <el-table-column prop="code" label="推荐码" width="100" />
        <el-table-column prop="memberUid" label="用户" width="100" />
        <el-table-column prop="withdrawSum" label="配图" width="240">
          <template slot-scope="scoped">
            <div style="display: flex;flex-wrap: wrap;">
                <el-image style="height: 60px;margin-left: 10px;max-width: 50px;" v-for="(item,index) in scoped.row.images" :key="index" :src="item" fit="fill" :preview-src-list="scoped.row.images" @click.stop="handleClickItem"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="领取状态" width="100">
          <template slot-scope="scoped">
            <div style="display: flex;align-items: center;justify-content: center;color:#06CC00" v-if="scoped.row.receiveStatus == 1">
              已领取 
            </div> 
            <div style="display: flex;align-items: center;justify-content: center;color: #999;" v-if="scoped.row.receiveStatus == 0">
              未领取
            </div>
          </template>
        </el-table-column> 
        <el-table-column prop="lastUploadDate" label="ip" width="170">
            <template slot-scope="scoped">
                <div>{{ scoped.row.ip }}</div>
                <div>{{ scoped.row.ipAddress }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="ipCount" label="重复数" width="100" />
        <el-table-column prop="lastUploadDate" label="上一次上传时间" width="170">
            <template slot-scope="scoped">
                <div  v-if="scoped.row.lastUploadDate">
                {{ happenTimeFun(scoped.row.lastUploadDate) }}
             </div>
          </template>
        </el-table-column>
        <el-table-column prop="c1" label="下级数量" width="100" />
        <el-table-column prop="createDate" label="创建时间" width="170" />
        <el-table-column prop="yf" label="乙方" width="100" />
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
    </div>
  </template>
  
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
  import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
  
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination,VueUeditorWrap,UploadImage },
    data() {
      return {
        option: "", // 初始选项
        options: [], // 选择角色
        name: "", // 搜索的管理员名称
        tableData: [], // 展示的表单信息
        // 添加表单
        active: {},
        // 修改表单
        editForm: { },
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        multipleSelection: [], // 选中项s
        yiFangDetailList: [], // 
        dialogVisible: false, // 添加弹窗
        dialog: false, // 添加弹窗
        edit_dialogVisible: false, // 编辑弹窗
        Isedit: false, // 是否是编辑弹窗
        loading: false, // 表格加
        buttongLoding: false, // 按钮加载
        sn:'',
        lang:'en',
        isEnabled:false,
        isChat:false,
        isTelegram:false,
        isWhatsApp:false,
        isMessenger:false,
        isLinkUrl:false,
        isTelegramGroup:false,
        dialogVisibleUpdate:false,
        dataTime:['',''],
        yifangId:'',
        status:'',
        uid:'',
        ip:'',
        ipCount:''
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      handleClickItem() {
        this.$nextTick(() => {
          // 获取遮罩层dom
          const domImageMask = document.querySelector('.el-image-viewer__mask')
          if (!domImageMask) {
            return
          }
          domImageMask.addEventListener('click', () => {
            // 点击遮罩层时调用关闭按钮的 click 事件
            document.querySelector('.el-image-viewer__close').click()
          })
        })
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
      },
      // 批量审核通过
    checkSuccessList(type,row){
        if(type == 1){
            var ids = [row.id];
            var params = {
               ids: ids.toString(),
            };
      this.$api.operate
        .approveList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });

        }
        if(type == 2){
            if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .approveList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      })

        }
    },
    checkRejectList(type,row){
        if(type == 1){
            var ids = [row.id];
            var params = {
               ids: ids.toString(),
            };
      this.$api.operate
        .rejectList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });

        }
      if(type == 2){
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否批量审核拒绝?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .rejectList(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
          
      }).catch(() => {
        
        });
      }
    },
      // 获取表单信息
      getList() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          uid:this.uid,
          status:this.status,
          ip:this.ip,
          ipCount:this.ipCount
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
          this.$api.operate
          .memberShareRecordList(params)
          .then((res) => {
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 选择或者取消行，支持全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 关闭添加弹窗
      handleClose() {
        this.$refs.active.resetFields();
      },
      // 关闭修改弹窗
      editClose(done) {
        this.editInfo = {};
        done();
      },
      // 删除选中项
      handleDel() {
        var ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        var params = {
          ids: ids.toString(),
        };
        this.$api.operate
          .bannerDelete(params)
          .then((res) => {
            this.$message.success(res);
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.getList();
          });
      },
      happenTimeFun(num){
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
  },
      // 添加用户
      bannerSave() {
            this.$api.operate
              .bannerSave(this.active)
              .then((res) => {
                this.$message.success(res);
                this.dialogVisible = false;
                this.getList();
              })
              .catch((err) => {
                this.$message.error(err || "服务器错误，请稍后重试");
              })
              .finally(() => {
                this.buttongLoding = false;
              });
      },
      // 打开删除弹窗
      openDelete() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleDel();
          })
          .catch(() => {
            
          });
      },
     
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  </style>
  